import { Box } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { createFileRoute, redirect, useRouter } from '@tanstack/react-router';
import { z } from 'zod';

import { Login } from '@/module/Security/Login';
import { LoginSchema } from '@/module/Security/model/LoginSchema';
import { useLogin } from '@/module/Security/model/SecurityQuery';

import { useCurrentUserStore } from '@feature/security';

const fallback = '/' as const;

export const Route = createFileRoute('/login')({
  component: LoginScreen,
  validateSearch: z.object({
    redirect: z.string().optional().catch(''),
  }),
  beforeLoad: ({ search, preload }) => {
    if (useCurrentUserStore.getState().isAuthenticated && !preload) {
      throw redirect({ to: search.redirect || fallback });
    }
  },
});

export function LoginScreen() {
  const router = useRouter();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  const { mutateAsync, isPending } = useLogin();

  const onLogin = async (data: LoginSchema) => {
    try {
      await mutateAsync(data);
      await router.invalidate();
      await navigate({ to: search.redirect || fallback });
    } catch (err: unknown) {
      // eslint-disable-next-line no-console
      console.error(err);
      notifications.show({
        color: 'red',
        title: 'Error',
        message: 'Please try again',
      });
    }

    return undefined;
  };

  return (
    <Box mt="3%">
      <Login
        onLogin={onLogin}
        isSubmitting={isPending}
      />
    </Box>
  );
}
